<template>
    <div class="faq-group">
        <slot name="title">
            <h2 class="faq-group--title">{{ title }}</h2>
        </slot>

        <accordion-item v-for="(item, idx) in items"
                :key="idx"
                :facets="['faq']"
                :ref="item.id"
                :is-open="isItemOpen(item.id)"
                :label="item.label"
                @open="onOpen(item.id)"
                @close="onClose"
        >
            <p class="u-raw-text" slot="content">
                <v-runtime-template :template="item.content"/>
            </p>
        </accordion-item>
    </div>
</template>

<script>
    import VRuntimeTemplate from 'v-runtime-template';
    import AccordionItem from 'framework/global-components/dyn/accordion-item/accordion-item';

    export default {
        components: { AccordionItem, VRuntimeTemplate },
        props: {
            title: {
                type: String,
                default: null,
            },

            /** @type {IFaqItem[]} */
            items: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                currentOpenItemIdx: null,
                currentScroll: null,
            };
        },

        methods: {
            isItemOpen(itemIdx) {
                return this.currentOpenItemIdx === itemIdx;
            },

            onOpen(idx) {
                location.hash = `#${ idx }`;
                this.currentOpenItemIdx = idx;
            },

            scrollToElement(idx) {
                if (this.currentScroll) {
                    return;
                }

                if (!this.$refs[idx]) {
                    return;
                }

                this.currentScroll = this.$scrollTo(this.$refs[idx][0].$el, 400, {
                    easing: 'ease-in',
                    offset: 10,
                    force: true,
                    cancelable: false,
                    x: false,
                    y: true,
                    onDone: () => {
                        this.currentScroll = null;
                    },
                });
            },

            onClose() {
                this.currentOpenItemIdx = null;
            },
        },

        mounted() {
            if (location.hash) {
                this.currentOpenItemIdx = location.hash.replace('#', '');
                this.scrollToElement(this.currentOpenItemIdx);
            }
        },
    };
</script>
